import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../../common/DesktopMenu/index";
import MobileMenu from "../../../../common/MobileMenu/index";
import useWindowSize from "../../../../common/windowSize";
import NewFooter from "../../../../common/NewFooter";
import BackButton from "../../../Products/BackButton";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import jwt_decode from "jwt-decode";
import VisibilityIcons from "./VisibilityIcons";
import { getCookie } from "../../../../utils/cookie";
import { toast } from "react-toastify";
import { privateAPI } from "../../../../utils/api";
import { useTranslation } from "react-i18next";
import { 
  Background, 
} from "../../../../common/Faq/styles";
import {
  SettingsHeader,
  Title
} from '../../styles';
import {
  UserInfoData,
  UserPasswordData,
  InfoWrapper,
  InputWrapper,
  LoginInput,
  LoginButton,
  ChangeEmailWrapper
} from './styles';

const UpdateInfo = () => {
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [userID] = useState(getCookie('userId'));
  const { t } = useTranslation();
  const [resetPassword, setResetPassword] = useState({});
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    password: false,
    repeatedPassword: false,
  });

  const updateUserInfo = async () => {
    setLoading(true);
    try {
      await privateAPI.put(`/auth/bacchus/client/user/${userID}`, userInfo);
      getUserById();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  }

  const getUserById = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/user/${userID}`);
      setUserInfo(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  const sendResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!resetPassword.oldPassword)
      return [toast.error("Password is empty"), setLoading(false)];
    if (!resetPassword.password)
      return [toast.error("New password is empty"), setLoading(false)];
    if (!resetPassword.repeatedPassword)
      return [toast.error("Repeated password is empty"), setLoading(false)];
    if (resetPassword.password !== resetPassword.repeatedPassword)
      return [toast.error("Passwords doesn't match"), setLoading(false)];

    try {
      const token = getCookie("token");
      const decoded = jwt_decode(token);
      delete resetPassword.repeatedPassword;

      await privateAPI.put(`/auth/bacchus/client/user/newpassword/${decoded.id}`, resetPassword );

      setResetPassword({});
      toast.success("Successfully changed password.");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };


  useEffect(() => {
    getUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>
            {t("updateYourInformation")}
          </Title>
        </SettingsHeader>
        <InfoWrapper>
          <UserInfoData>
            <label htmlFor="name">{t("name")}:</label>
            <input 
              type="text" 
              id="name" 
              required
              value={userInfo.name || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                name: e.target.value })
              }
              placeholder={t("enterName")}
              disabled={loading}
              />
            <label htmlFor="surname">{t("lastName")}</label>
            <input 
              type="text" 
              id="surname" 
              required
              value={userInfo.surname || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                surname: e.target.value })
              }
              placeholder={t("enterLastName")}
              disabled={loading}
              />
            <label htmlFor="address">{t("address")}</label>
            <input 
              type="text" 
              id="address" 
              required
              value={userInfo.address || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                address: e.target.value })
              }
              placeholder={t("enterAddress")}
              disabled={loading}
              />
            <label htmlFor="place">{t("city")}</label>
            <input 
              type="text" 
              id="place" 
              required
              value={userInfo.place || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                place: e.target.value })
              }
              placeholder={t("enterCity")}
              disabled={loading}
              />
            <label htmlFor="postCode">{t("postalCode")}</label>
            <input 
              type="text" 
              id="postCode" 
              required
              value={userInfo.postCode || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                postCode: e.target.value })
              }
              placeholder={t("enterPostalCode")}
              disabled={loading}
              />
            <label htmlFor="phone">{t("contactPhone")}</label>
            <input 
              type="text" 
              id="phone" 
              required
              value={userInfo.phone || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                phone: e.target.value })
              }
              placeholder={t("enterPhone")}
              disabled={loading}
              />
            <label htmlFor="username">{t("contactEmail")}</label>
            <input 
              type="text" 
              id="username" 
              required
              value={userInfo.username || ''}
              onChange={(e) => setUserInfo({
                ...userInfo,
                username: e.target.value })
              }
              placeholder={t("enterPostalCode")}
              disabled={true}
              />
            <button onClick={updateUserInfo}>{loading ? `${t("loading")}...` : t("send")}</button>
          </UserInfoData>
          <UserPasswordData>
            <InputWrapper>
              <label>{t("yourOldPassword")}</label>
              <LoginInput
                type={showPassword?.oldPassword ? "text" : "password"}
                placeholder="Old password"
                disabled={loading}
                autocomplete="off"
                onChange={(e) =>
                  setResetPassword({
                    ...resetPassword,
                    oldPassword: e.target.value,
                  })
                }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.oldPassword}
                  typePassword={"oldPassword"}
                />
              </InputWrapper>
              <InputWrapper>
                <label>{t("yourNewPassword")}</label>
                <LoginInput
                  type={showPassword.password ? "text" : "password"}
                  placeholder="New password"
                  disabled={loading}
                  onChange={(e) =>
                    setResetPassword({
                      ...resetPassword,
                      password: e.target.value,
                    })
                  }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.password}
                  typePassword={"password"}
                />
              </InputWrapper>
              <InputWrapper>
                <label>{t("repeatYourNewPassword")}</label>
                <LoginInput
                  type={showPassword.repeatedPassword ? "text" : "password"}
                  placeholder="Repeat new password"
                  disabled={loading}
                  onChange={(e) =>
                    setResetPassword({
                      ...resetPassword,
                      repeatedPassword: e.target.value,
                    })
                  }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.repeatedPassword}
                  typePassword={"repeatedPassword"}
                />
              </InputWrapper>
              <LoginButton
                type="submit"
                value="Submit"
                disabled={loading}
                onClick={(e) => sendResetPassword(e)}
                >
                {loading ? "Loading..." : "Change"}
              </LoginButton>
            <ChangeEmailWrapper>
              <p>{t("changeEmail")}</p>
            </ChangeEmailWrapper>
          </UserPasswordData>
        </InfoWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default UpdateInfo;
